import { LibraryActionTypes } from './libraryTypes';

export const libraryApiResponseSuccess = (actionType: string, data: any) => ({
  type: LibraryActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const libraryApiResponseError = (actionType: string, error: string) => ({
  type: LibraryActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const fetchInsights = (page = 1) => ({
  type: LibraryActionTypes.FETCH_INSIGHTS,
  payload: { page },
});

export const fetchInsightById = (id: string) => ({
  type: LibraryActionTypes.FETCH_INSIGHT_BY_ID,
  payload: { id },
});

export const deleteInsight = (id: string) => ({
  type: LibraryActionTypes.DELETE_INSIGHT,
  payload: { id },
});

export const setLibraryPage = (page: number) => ({
  type: LibraryActionTypes.SET_PAGE,
  payload: { page },
});
